define('TescoMobile_Checkout/js/view/summary/clubcard-points',['ko', 'uiComponent', 'Magento_Checkout/js/model/quote', 'Magento_Customer/js/customer-data', 'Magento_Checkout/js/model/totals'], function (ko, Component, quote, customerData, totals) {
  'use strict';

  return Component.extend({
    totals: quote.getTotals(),
    initialize: function () {
      this._super();
      this.cart = customerData.get('cart');
    },
    isDisplayed: function () {
      return this.getValue() > 0;
    },
    getValue: function () {
      var segment,
        amount = 0;
      if (this.totals()) {
        segment = totals.getSegment('pay_up_front');
        if (segment && segment['extension_attributes']) {
          return segment['extension_attributes']['clubcard_points_amount'];
        }
      }
      return amount;
    }
  });
});

